"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var BlDropzoneThumb_1 = __importDefault(require("../BlDropzone/BlDropzoneThumb"));
var useMediaPreview_1 = require("../../../hooks/useMediaPreview");
var mediaHelper_1 = require("../../../helpers/mediaHelper");
var Icon_1 = __importDefault(require("../../Icon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var baseStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
};
var activeStyle = {
    borderColor: '#2196f3',
};
var acceptStyle = {
    borderColor: '#00e676',
};
var rejectStyle = {
    borderColor: '#ff1744',
};
var BlSingleDropzone = function (_a) {
    var value = _a.value, onRemoved = _a.onRemoved, onChange = _a.onChange;
    var openPreview = useMediaPreview_1.useMediaPreview();
    var _b = react_dropzone_1.useDropzone({
        onDrop: function (acceptedFiles) {
            onAdd(acceptedFiles[0]);
        },
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive, isDragAccept = _b.isDragAccept, isDragReject = _b.isDragReject;
    var style = react_1.useMemo(function () { return (__assign(__assign(__assign(__assign({}, baseStyle), (isDragActive ? activeStyle : {})), (isDragAccept ? acceptStyle : {})), (isDragReject ? rejectStyle : {}))); }, [isDragActive, isDragReject, isDragAccept]);
    var onRemove = function (id) {
        onRemoved(id);
    };
    var onAdd = function (file) {
        if (value) {
            return;
        }
        onChange(file);
    };
    var composePreviewMedia = function () {
        return __assign(__assign({}, value), { url: value.path });
    };
    if (value) {
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement(BlDropzoneThumb_1.default, { path: mediaHelper_1.resolveThumb(value), onClick: function () {
                    openPreview([composePreviewMedia()], 0);
                }, onRemove: function () {
                    onRemove(value.id);
                } })));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", __assign({}, getRootProps({ style: style })),
            react_1.default.createElement("input", __assign({}, getInputProps(), { className: styles_module_scss_1.default.file_input })),
            react_1.default.createElement(Icon_1.default, { semanticName: "image outline", className: styles_module_scss_1.default.icon }))));
};
exports.default = BlSingleDropzone;
